function trimField(value) {
    if (value == null) {
        return "";
    }
    return String(value).trim();
}

export function isDirectComputeRequest(body) {
    const country = trimField(body?.country);
    const elecRegion = trimField(body?.elec_region);
    const hasCountryAndRegion =
        Boolean(country) && Boolean(elecRegion) && elecRegion.toUpperCase() !== "ALL";
    const hasCustomDates =
        Boolean(trimField(body?.start_date)) && Boolean(trimField(body?.end_date));
    const hasSite = Boolean(trimField(body?.site_name));
    return hasCountryAndRegion || hasCustomDates || hasSite;
}
